/*
 * @Author: your name
 * @Date: 2020-10-13 00:44:44
 * @LastEditTime: 2021-05-18 11:14:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\ExtraObject.js
 */
/**
 * @Description 附加对象类，可存在于上帝视角中, 不可交互
 * @Author Kida
 * @Date 2020-10-11
 * @Version 1.0
 */

import * as THREE from 'three'
import enableInlineVideo from 'iphone-inline-video'

export class VerticalVedioPanel extends THREE.Mesh {
  /**
   *Creates an instance of VedioPanel.
   * @param {String} id 特有ID
   * @param {String} title 标题（名字）
   * @param {THREE.Vector3} pos0 对角点坐标1
   * @param {THREE.Vector3} pos1 对角点坐标2
   * @param {THREE.Vector3} camPos 相机坐标
   * @param {String} videoUrl 视频的url
   * @memberof VedioPanel
   */
  constructor (id, title, pos0, pos1, camPos, videoUrl, playImmediately = false) {
    const dz = pos1.z - pos0.z
    const dy = pos1.y - pos0.y
    const dx = pos1.x - pos0.x

    // 平面法向，未归一，永远水平
    const normalVec = new THREE.Vector3(dz, 0, -dx)
    const geo = new THREE.PlaneBufferGeometry(normalVec.length(), Math.abs(dy))
    super(geo)

    const center = pos0.clone().add(pos1).multiplyScalar(0.5)
    this.position.copy(center)
    this.lookAt(camPos.clone().sub(center).dot(normalVec) < 0 ? center.sub(normalVec) : center.add(normalVec))

    const video = document.createElement('video')

    video.setAttribute('webkit-playsinline', 'true')
    video.setAttribute('playsinline', 'true')

    // video.setAttribute('x5-playsinline', 'true')

    video.setAttribute('x-webkit-airplay', 'true')
    video.setAttribute('x5-video-player-type', 'h5')
    video.setAttribute('crossorigin', 'anonymous')

    video.loop = true
    video.muted = true
    video.controls = false
    video.autoplay = false
    video.src = videoUrl

    enableInlineVideo(video)
    this.video = video
    this.video.load()

    let mat = null
    if (false) {
      this.canvas = document.createElement('canvas')
      this.ctx = this.canvas.getContext('2d')
      this.canvas.height = 256
      this.canvas.width = 256
      const tex = new THREE.CanvasTexture(this.canvas)
      mat = new THREE.MeshBasicMaterial({ map: tex, side: THREE.FrontSide })
    } else { }

    const tex = new THREE.VideoTexture(video)
    mat = new THREE.MeshBasicMaterial({ map: tex, side: THREE.FrontSide })
    this.material = mat

    if (false) {
      this.video.width = 0
      this.video.height = 0

      const dom = document.body

      dom.appendChild(this.video)
    }
    mat.polygonOffsetFactor = 0.0
    mat.polygonOffsetUnits = 1.0
    mat.depthTest = true
    mat.depthWrite = true

    this.hpType = 'VideoPlane'
    this.name = title
    this.extraId = id
    this.title = title

    if (playImmediately) {
      this.play()
    }
  }

  play () {
    this.video.play()
    if (this.canvas) {
      const scope = this
      this.canvas.width = 1920// scope.video.videoWidth
      this.canvas.height = 1080// scope.video.videoHeight
      scope.timer = setInterval(function () {
        scope.ctx.drawImage(scope.video, 0, 0, scope.video.videoWidth / 2, scope.video.videoHeight / 2)
        scope.material.map.needsUpdate = true
      }, 50)
    }
  }

  pause () {
    this.video.pause()
    if (this.canvas) {
      clearInterval(this.timer)
    }
  }

  get paused () {
    return this.video.paused
  }
}

export class ExtraObjectSet {
  constructor () {
    /**
     * @type {VerticalVedioPanel[]}
     */
    this.objects = []

    this.group = new THREE.Group()
  }

  /**
   * 添加额外物体
   * @param {*} obj
   * @memberof ExtraObjectSet
   */
  addObject (obj) {
    this.objects.push(obj)
    this.group.add(obj)
  }

  getObject (id) {
    for (const obj of this.objects) {
      if (obj.extraId === id) {
        return obj
      }
    }
    return null
  }

  /**
   * 移除额外物体
   * @param {*} obj
   * @memberof ExtraObjectSet
   */
  removeObject (obj) {
    this.group.remove(obj)
    for (let i = 0; i < this.objects.length; i++) {
      if (obj === this.objects[i]) {
        this.objects.splice(i, 1)
        break
      }
    }
  }
}
